import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=6cb60ff1&scoped=true&"
import script from "./page-not-found.ts?vue&type=script&lang=ts&"
export * from "./page-not-found.ts?vue&type=script&lang=ts&"
import style0 from "./page-not-found.scss?vue&type=style&index=0&id=6cb60ff1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb60ff1",
  null
  
)

export default component.exports